<template>
    <el-container>
        <el-header>
            <el-row :gutter="20">
                <el-col :span="6"
                    >{{ $t('common.SRC_ID') }}（{{ $t('common.PRODUCER') }}）
                    <td-input v-model="producerId"></td-input>
                </el-col>
                <el-col :span="4"
                    >{{ $t('common.ROUTING_KEY') }}
                    <td-input v-model="proRootingKey"></td-input>
                </el-col>
                <el-col :span="6"
                    >{{ $t('common.MESSAGE') }}
                    <td-input v-model="sendInfo"></td-input>
                </el-col>
                <el-col :span="4">
                    <td-button type="primary" :loading="loading" @click="btnSendInfo">{{ $t('common.SEND_MESSAGE') }}</td-button>
                </el-col>
            </el-row>
            <hr />
            <el-row :gutter="20">
                <el-col :span="6"
                    >{{ $t('common.SRC_ID') }}（{{ $t('common.CONSUMER') }}）
                    <td-input v-model="consumerId"></td-input>
                </el-col>
                <el-col :span="4"
                    >{{ $t('common.ROUTING_KEY') }}
                    <td-input v-model="conRootingKey"></td-input>
                </el-col>
                <el-col :span="2">
                    <td-button type="primary" :loading="loading" @click="btnSubscribeInfo">{{ $t('common.SUBSCRIBE_MESSAGE') }}</td-button>
                </el-col>
                <el-col :span="2">
                    <td-button type="primary" :loading="loading" @click="btnUnSubscribeInfo">{{ $t('common.UNSUBSCRIBE_MESSAGE') }}</td-button>
                </el-col>
            </el-row>
        </el-header>
        <el-main>
            <el-row :gutter="20"> </el-row>
            <el-row>
                <el-col :span="24">
                    <!-- 加载表格 -->
                    <td-table :columns="columns" :dataSource="tableData1" :hasPage="false"></td-table>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
var tableData = [];
//订阅信息回调方法
function reciveCallback(message) {
    if (message.body) {
        let body = {
            body: JSON.parse(message.body)
        };
        tableData.push(body);
    } else {
        this.$message.error('got empty message');
    }
}
export default {
    // 初始化渲染
    components: {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.tableData1 = tableData;
    },
    // 定义数据
    data() {
        return {
            producerId: '6e1a182c-793a-4f22-b8d5-ba150641ec1e', //生产者id
            consumerId: 'eb05f3b1-380d-4362-9df4-5676510af37a', //消费者id
            proRootingKey: '', //生产者路由键
            sendInfo: '', //发送的消息
            conRootingKey: '', //消费者路由键
            columns: [
                {
                    prop: 'body',
                    label: 'common.MESSAGE'
                }
            ],
            tableData1: [] // 列表数据
        };
    },
    // 方法的实现
    methods: {
        //发送信息
        btnSendInfo() {
            if (this.$util.isEmpty(this.producerId)) {
                //this.$message.error(('请输入生产者id');
                this.$message.error(this.$t('common.PLEASE_ENTER_THE_PRODUCER_ID'));
                return;
            }
            if (this.$util.isEmpty(this.proRootingKey)) {
                this.$dataBusUtil.sendMsg(this.producerId, this.sendInfo);
            } else {
                this.$dataBusUtil.sendMsgByRoutingKey(this.producerId, this.proRootingKey, this.sendInfo);
            }
        },
        //订阅信息
        btnSubscribeInfo() {
            if (this.$util.isEmpty(this.consumerId)) {
                //this.$message.error('请输入消费者id');
                this.$message.error(this.$t('common.PLEASE_ENTER_THE_CONSUMER_ID'));
                return;
            }
            if (this.$util.isEmpty(this.conRootingKey)) {
                this.$dataBusUtil.receiveMsg(this.consumerId, reciveCallback);
            } else {
                this.$dataBusUtil.receiveMsgByRoutingKey(this.consumerId, this.conRootingKey, reciveCallback);
            }
        },
        //取消订阅
        btnUnSubscribeInfo() {
            if (this.$util.isEmpty(this.consumerId)) {
                //this.$message.error('请输入消费者id');
                this.$message.error(this.$t('common.PLEASE_ENTER_THE_CONSUMER_ID'));
                return;
            }
            this.$dataBusUtil.unSubscribeMsg(this.consumerId);
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
